import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import Container from 'common/Container';
import ProgramGridByNiche from 'components/ProgramGridByNiche';
import { countActivePrograms, programGridByNiche } from '../TNOBusinessLevel/businessLevelPresentationData';
import NicheIllustration from 'components/ProgramGridByNiche/NicheIllustration';
import { getTnoHeroGradient } from '../../../theme/tnoBrandColors';

const LandingMediaKitProgramacion = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const programCount = countActivePrograms();
  const nicheCount = programGridByNiche.length;
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary?.main || '#00838f';
  const heroBackground = getTnoHeroGradient(primary, secondary);

  return (
    <Box
      sx={{
        pb: 6,
        background: `linear-gradient(180deg, ${alpha(primary, 0.04)} 0%, ${alpha(secondary, 0.06)} 12%, transparent 28%)`,
      }}
    >
      <Container>
        <Box pt={{ xs: 3, md: 4 }} pb={3}>
          <Button
            component={RouterLink}
            to="/"
            startIcon={<ArrowBackIcon />}
            color="primary"
            sx={{ mb: 3, borderRadius: 999 }}
          >
            Volver al media kit
          </Button>

          <Box
            sx={{
              borderRadius: { xs: 3, md: 4 },
              overflow: 'hidden',
              mb: 4,
              background: heroBackground,
              color: '#fff',
              px: { xs: 2.5, md: 4 },
              py: { xs: 4, md: 5 },
              position: 'relative',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                width: 220,
                height: 220,
                borderRadius: '50%',
                top: -60,
                right: -40,
                bgcolor: 'rgba(255,255,255,0.12)',
                pointerEvents: 'none',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: 12,
                right: { xs: 12, md: 24 },
                opacity: 0.35,
                pointerEvents: 'none',
                display: { xs: 'none', sm: 'block' },
              }}
            >
              <NicheIllustration type="news" width={72} color="#fff" />
            </Box>
            <Box
              component="img"
              src="/images/logos/logo_white.PNG"
              alt="TNO Network"
              sx={{
                height: { xs: 44, md: 52 },
                width: 'auto',
                display: 'block',
                mb: 2,
                filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.2))',
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 2.5, opacity: 0.9, fontSize: '0.8rem' }}
            >
              TNO Network · Parrilla comercial
            </Typography>
            <Typography
              component="h1"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '2.2rem', md: '3rem' },
                lineHeight: 1.05,
                mt: 1,
                mb: 2,
                maxWidth: 640,
              }}
            >
              Programación por nichos
            </Typography>
            <Typography sx={{ fontSize: { xs: '1rem', md: '1.12rem' }, lineHeight: 1.65, maxWidth: 600, opacity: 0.92, mb: 3 }}>
              Explora producciones en antena y On-Demand agrupadas por temática. Cada color representa un vertical del
              ecosistema para ubicar tu marca con contexto.
            </Typography>
            <Grid container spacing={1.5}>
              <Grid item>
                <Chip
                  icon={<LiveTvIcon />}
                  label={`${programCount}+ producciones`}
                  sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 700 }}
                />
              </Grid>
              <Grid item>
                <Chip label={`${nicheCount} nichos`} sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: '#fff', fontWeight: 600 }} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>

      <Container>
        <ProgramGridByNiche
          variant={themeMode === 'dark' ? 'dark' : 'light'}
          richLayout
          showQuickNav
          showHeader={false}
        />
      </Container>
    </Box>
  );
};

LandingMediaKitProgramacion.propTypes = {
  themeMode: PropTypes.string,
};

LandingMediaKitProgramacion.defaultProps = {
  themeMode: 'light',
};

export default LandingMediaKitProgramacion;
